export default class Helper {

    // For app download, etc.
    static getOS() {
        let os = null;
        const userAgent    = window.navigator.userAgent,
              platform     = window.navigator.platform,
              macPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
              winPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];

        if (macPlatforms.indexOf(platform) !== -1) {
            os = 'Mac';
        } else if (winPlatforms.indexOf(platform) !== -1) {
            os = 'Windows';
        } else if (userAgent.match(/Android/i)) {
            os = 'Android';
        } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
            os = 'iOS'
        }
        return os;
    }


    // Custom regex check for email
    static isEmailValid(emailStr) {
        return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(emailStr);
    }


    // For lead information
    static getBrowserInformation() {
        try {
            let browserDetails = navigator.userAgent,
                user = browserDetails.toLowerCase(),
                browser = "";
            if (user.indexOf("msie") != -1) {
                var substring = browserDetails.substring(browserDetails.indexOf("MSIE")).split(";")[0];
                browser = substring.split(" ")[0].replace("MSIE", "IE") + "-" + substring.split(" ")[1];
            } else if (user.indexOf("safari") != -1 && user.indexOf("version") != -1) {
                browser = (browserDetails.substring(browserDetails.indexOf("Safari")).split(" ")[0]).split("/")[0] + "-" + (browserDetails.substring(browserDetails.indexOf("Version")).split(" ")[0]).split("/")[1];
            } else if (user.indexOf("opr") != -1 || user.indexOf("opera") != -1) {
                if (user.indexOf("opera") != -1)
                    browser = (browserDetails.substring(browserDetails.indexOf("Opera")).split(" ")[0]).split("/")[0] + "-" + (browserDetails.substring(browserDetails.indexOf("Version")).split(" ")[0]).split("/")[1];
                else if (user.indexOf("opr") != -1)
                    browser = ((browserDetails.substring(browserDetails.indexOf("OPR")).split(" ")[0]).replace("/", "-")).replace("OPR", "Opera");
            } else if (user.indexOf("chrome") != -1) {
                browser = (browserDetails.substring(browserDetails.indexOf("Chrome")).split(" ")[0]).replace("/", "-");
            } else if ((user.indexOf("mozilla/7.0") > -1) || (user.indexOf("netscape6") != -1) || (user.indexOf("mozilla/4.7") != -1) || (user.indexOf("mozilla/4.78") != -1) || (user.indexOf("mozilla/4.08") != -1) || (user.indexOf("mozilla/3") != -1)) {
                browser = "Netscape-?";
            } else if (user.indexOf("firefox") != -1) {
                browser = (browserDetails.substring(browserDetails.indexOf("Firefox")).split(" ")[0]).replace("/", "-");
            } else if (user.indexOf("rv") != -1) {
                browser = "IE-" + user.substring(user.indexOf("rv") + 3, user.indexOf(")"));
            } else {
                browser = "Unknown";
            }
            return browser;
        } catch (err) {
            console.error("Error in getBrowserInformation", err);
        }
        return null;
    }


    // For lead information
    static getOSInformation() {
        try {
            let browserDetails = navigator.userAgent,
                os = "";
            if (browserDetails.toLowerCase().indexOf("windows") >= 0) {
                os = "Windows";
            } else if (browserDetails.toLowerCase().indexOf("mac") >= 0) {
                os = "Mac";
            } else if (browserDetails.toLowerCase().indexOf("x11") >= 0) {
                os = "Unix";
            } else if (browserDetails.toLowerCase().indexOf("android") >= 0) {
                os = "Android";
            } else if (browserDetails.toLowerCase().indexOf("iphone") >= 0) {
                os = "IPhone";
            } else {
                os = "Unknown";
            }
            return os;
        } catch (err) {
            console.error("Error in getOSInformation", err);
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/js/helper.js